var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVectorImmune = function SvgVectorImmune(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.828 17.342c-1.948-.49-3.556-1.608-4.824-3.353C.736 12.244.102 10.307.102 8.177V3.74a1 1 0 0 1 .648-.936L6.477.657a1 1 0 0 1 .702 0l5.727 2.148a1 1 0 0 1 .649.936v4.436c0 2.13-.634 4.067-1.903 5.812-1.268 1.745-2.876 2.862-4.824 3.353Zm0-1.766c1.458-.462 2.663-1.387 3.616-2.775a7.986 7.986 0 0 0 1.429-4.624v-3.28a1 1 0 0 0-.649-.936L7.18 2.444a1 1 0 0 0-.702 0L2.432 3.96a1 1 0 0 0-.649.936v3.28c0 1.696.477 3.237 1.43 4.624.953 1.388 2.158 2.313 3.615 2.775Z",
    fill: "#479DA6"
  })));
};
export default SvgVectorImmune;